import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { DeliveryAddressCard } from './DeliveryAddressCard';
import { DeliveryPreselectedCardView } from './DeliveryPreselectedCardView';
import { PreviewWithValidationError } from './PreviewWithValidationError';
export const AddressPreview = ({ address, showTitle = true, testId = 'hd_address_card', isValid = true, onEdit, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    if (!address) {
        return null;
    }
    const handleEdit = () => {
        onEdit(isValid ? undefined : address.deliveryAddressId);
    };
    return (_jsx(PreviewWithValidationError, { isValid: isValid, children: _jsx(DeliveryPreselectedCardView, { testId: testId, state: isValid ? 'resting' : 'error', header: _jsxs(_Fragment, { children: [showTitle && _jsx(TextAlpha, { strong: true, children: t('checkout.delivery.customer.details.title') }), _jsx(DeliveryAddressCard, { address: address })] }), onEdit: handleEdit }) }));
};
